import * as  React from 'react';
import { connect } from 'react-redux';
import { IMasonryComponentProps } from "./IMasonryComponentProps";
import { IMasonryComponentState } from "./IMasonryComponentState";
import axios from 'axios';
import Loader from 'react-loader-spinner'
import heart from 'src/assets/images/heart2.png'
import 'src/assets/css/item.css'

import {Placeholder} from 'semantic-ui-react'
import { Link, withRouter } from 'react-router-dom'
const masonryOptions = {
	transitionDuration: 2,
	columnWidth: 80
};

import Palette from 'react-palette'
import PostComponent from '../PostComponent';

const NoMoreItems = () => (
	<div>
		<p
			style={{
				fontSize: "20px",
				color: "black",
				fontFamily: "Gotham_Bold"
			}}
		>
			AUCUN GIF A VOIR ICI ... 🤔
		</p>
	</div>
)

class MasonryComponent extends React.Component<IMasonryComponentProps, IMasonryComponentState> {

	constructor(props: IMasonryComponentProps) {
		super(props);
		this.state = {
			tracks: [],
			nextHref: undefined,
			bottom: false,
			images: [],
			noMoreItems: false,
			loading: false,
			firstTime: true
		};
		this.handleScroll = this.handleScroll.bind(this);

	}

	componentDidMount() {
        window.addEventListener("scroll", this.handleScroll, true);

        console.log('Favorites')



		if (this.props.elastic == true) {
			this.fetchMoreData(this.state.nextHref, this.state.firstTime, this.props.params, false)
        }

        else if (this.state.firstTime)
        this.fetchMoreData(this.state.nextHref, this.state.firstTime, this.props.params, true)
	}

	componentWillReceiveProps(nextProps: Readonly<IMasonryComponentProps>, nextContext: any): void {

		if (this.props.elastic && this.props.params !== nextProps.params) {
			this.setState({
				noMoreItems: false,
				images: [],
				firstTime: this.props.elastic ? true : this.state.firstTime,
				loading: false
			}, () => {
				this.fetchMoreData(this.state.nextHref, this.state.firstTime, nextProps.params, false)
			})
		}
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", this.handleScroll, true)
	}

	fetchMoreData = (lastGif, first, params, scroll) => {


		if (this.state.loading)
			return

		if (!scroll) {
			this.setState({
				...this.state,
				images: [],
				nextHref: undefined,
				noMoreItems: false,
				loading: true
			})
		}

		let end = false

		if (this.state.noMoreItems)
			return

		this.setState({
			loading: true
		})

        let url = ''



		if (first) {
            if (this.props.uid) {
                url = this.props.url + '&size=' + this.props.size
            } else {
                url = this.props.url + '?size=' + this.props.size
            }

			this.setState({ firstTime: false })
		} else {
            if (this.props.uid) {
                url = this.props.url + '&size=' + this.props.size
            } else {
                url = this.props.url + '?size=' + this.props.size + '&from=' + lastGif
            }
        }


		if (this.props.elastic) {
			console.log(url, params)
			axios.post(url, params)
				.then(res => {
					let objects = []
					if (this.props.similaire) {
						res.data.hits.hits.forEach(item => {
							console.log(item._id  , this.props.similaire.id)
							if(item._id !== this.props.similaire.id)
							{
								console.log('innnnnn ')
								objects.push(item._source)
							}
						})
						console.log('objects similaire ' , objects)
					} else {
						res.data.hits.hits.forEach(item => {
						objects.push(item._source)
						})

						console.log('objects nooo similaire ' , objects)
					}

					if (objects.length < this.props.size) {
						end = true
					}
					this.setState({
						...this.state
						, images: [...this.state.images, ...objects],
						nextHref: objects.length > 0 ? objects.length - 1 : -1,
						noMoreItems: end,
						loading: false
					})
				})
		} else {


			axios.get(url, this.props.params)
				.then(res => {
						if (res.data.length < this.props.size) {
							end = true
						}
						this.setState({
							...this.state,
							images: [...this.state.images, ...res.data],
							nextHref: res.data.length > 0 ? res.data[res.data.length - 1].key : undefined,
							noMoreItems: end,
							loading: false
						})
				})
		}


	};

	handleScroll = (event) => {
		let items = []
		const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
		const body = document.body;
		const html = document.documentElement;
		const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = Math.round(windowHeight + window.pageYOffset);

		if (windowBottom >= docHeight - 200) {
			this.fetchMoreData(this.state.nextHref, this.state.firstTime, this.props.params, true)
		}
	}

	chunk(arr) {
		let i = 0,
			chunk;

		const sets = [];

		while (arr.length > 0) {
			if (i % 2 === 0) chunk = arr.splice(0, 2);
			else chunk = arr.splice(0, 3);

			i++;

			sets.push(chunk);
		}

		return sets;
	}

	render() {
		const gifs = [...this.state.images]

		const NoMoreItems = () => (
			<div>
				<p
					style={{
						fontSize: "20px",
						color: "black",
						fontFamily: "Gotham_Bold"
					}}
				>
					AUCUN GIF A VOIR ICI ... 🤔
				</p>
			</div>
		)
		return (
			<div className='_allGifs'  >
				<div className='container'>
					<h2 style={{
						marginBottom: '15px',
						marginLeft: '3px',
						cursor: 'context-menu',
						color: this.props.title === 'GIF SMILAIRES' ? 'white' : null ,
					}}>{ gifs.length> 0 ? this.props.title : this.props.title }</h2>
					<div className=""
						style={{
							display: "flex",
							flexDirection: "row",
							flexWrap: "wrap",
							flex: 1,
							width: "100%"
						}}
					>
						{
							gifs && gifs.length
							?	this.chunk(gifs).map((chunk, index) =>
									chunk.map(item => (
										<PostComponent
											key={`${item.id}`}
											URL={item.URL}
											id={item.id}
											favorites={item.favorites}
											title={item.title}
											half={chunk.length == 2}
										/>
									))
								)

							:null
						}



						{
							this.state.loading && !this.state.noMoreItems

							?	<Loader type="Plane" color="#f34c71" height={80} width={80} />

							:	null
						}

						
					</div>


					{
						this.state.images == 0 && !this.state.loading

							? <div
								style={{
									display: "flex",
									flexDirection: "row",
									flexWrap: "wrap",
									flex: 1,
									width: "100%",
									justifyContent: 'center'
								}}
							>
								<NoMoreItems/>
							</div>

							: null
					}
				</div>
			</div>

		);
	}
}

function mapStateToProps(state) {
	return {
		items: state.pagination.newGifs
	};
}

const mapDispatchToProps = (dispatch: any, ownProps: IMasonryComponentProps) => {
	return {

	}
}

export default connect(
	mapStateToProps, mapDispatchToProps
)(withRouter(MasonryComponent))



// WEBPACK FOOTER //
// ./src/components/masonryComponent/MasonryComponent.tsx